// src/config/apiConfig.js
// Backend API Configuration with pagination support
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// API endpoints configuration based on your backend routes
export const API_ENDPOINTS = {
  // Photos endpoints with pagination support
  photos: {
    getAll: (params = {}) => {
      const queryString = new URLSearchParams(params).toString();
      return `${API_BASE_URL}/historical-photos${queryString ? `?${queryString}` : ''}`;
    },
    getById: (id) => `${API_BASE_URL}/historical-photos/${id}`,
    getFilters: `${API_BASE_URL}/gallery-filters`,
    getTags: `${API_BASE_URL}/tags`
  },
  // QR Code endpoints (you'll need to add these to your backend)
  qrCodes: {
    getAll: `${API_BASE_URL}/qr-codes`,
    getByLocation: (location) => `${API_BASE_URL}/qr-codes/${location}`
  },
  // Composite images (you'll need to add these to your backend)
  composite: {
    create: `${API_BASE_URL}/composite`,
    upload: `${API_BASE_URL}/composite/upload`
  },
  // Health check
  health: `${API_BASE_URL}/health`
};

// Common API client methods with enhanced error handling
export const apiClient = {
  // GET request with query parameters support
  get: async (url, params = {}) => {
    try {
      // If url is a function, call it with params
      const finalUrl = typeof url === 'function' ? url(params) : url;
      
      console.log(`Making GET request to: ${finalUrl}`);
      const response = await fetch(finalUrl);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      // Handle the response format from your backend
      if (data.success) {
        return data; // Return the full response including pagination data
      } else {
        throw new Error(data.error || 'API error');
      }
    } catch (error) {
      console.error('API GET error:', error);
      throw error;
    }
  },

  // POST request
  post: async (url, data) => {
    try {
      console.log(`Making POST request to: ${url}`);
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const result = await response.json();
      
      if (result.success) {
        return result.data;
      } else {
        throw new Error(result.error || 'API error');
      }
    } catch (error) {
      console.error('API POST error:', error);
      throw error;
    }
  },

  // POST with FormData (for file uploads)
  postFormData: async (url, formData) => {
    try {
      console.log(`Making POST FormData request to: ${url}`);
      const response = await fetch(url, {
        method: 'POST',
        body: formData // Don't set Content-Type, let browser set it with boundary
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const result = await response.json();
      
      if (result.success) {
        return result.data;
      } else {
        throw new Error(result.error || 'API error');
      }
    } catch (error) {
      console.error('API POST FormData error:', error);
      throw error;
    }
  },

  // DELETE request
  delete: async (url) => {
    try {
      console.log(`Making DELETE request to: ${url}`);
      const response = await fetch(url, {
        method: 'DELETE'
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const result = await response.json();
      
      if (result.success) {
        return result.data;
      } else {
        throw new Error(result.error || 'API error');
      }
    } catch (error) {
      console.error('API DELETE error:', error);
      throw error;
    }
  }
};